// based on rc-tree 2.1.3
'use strict';

module.exports = require('./src/');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-tree/index.js
// module id = TsDU
// module chunks = 16